import Vue from "vue";
import vSelect from "vue-select";

function cloneDeep(object) {
    return JSON.parse(JSON.stringify(object));
}

function initCompleteInfo() {
    var el = document.getElementById("complete-info-app");
    if (!el) return;

    Vue.component("v-select", vSelect);

    var token = el.getAttribute("data-token");

    var app = new Vue({
        el: el,
        delimiters: ["${", "}"],
        data: {
            loading: false,
            allCities: window.allCities,
            orderWantsInvoice: document.getElementById("orderWantsInvoice")
                ? document.getElementById("orderWantsInvoice").checked
                : false,
            billingAddressZipCode: document.getElementById("billingAddressZipCode")
                ? document.getElementById("billingAddressZipCode").value
                : "",
            billingAddressCity: document.getElementById("billingAddressCity")
                ? document.getElementById("billingAddressCity").value
                : ""
        },
        mounted: async function() {
            this.loading = false;
        },
        computed: {},
        methods: {
            onChangeBillingCity: function(newValue) {
                this.billingAddressZipCode = this.allCities.filter(
                    x => x.title == newValue
                )[0].zipCode;
            }
        },
        watch: {}
    });
}

export default function init() {
    initCompleteInfo();
}
